import React, { useState, useEffect } from 'react';
import Button from "components/CustomButton";
import Loader from 'components/Loader';
import GeneralService from 'services/GeneralService';
import CustomTextArea from 'components/CustomTextArea';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useTeamContext } from "store/contexts/teamContext";

function SelectionModal({ sendToS3, continueToGenerate, attachment, clearAttachment }) {
	const [progressBar, setUploadProgress] = useState(0);
	const [loading, setLoading] = useState(false);
	const [displayInputField, setDisplayInputField] = useState(false);
	const { team } = useTeamContext();

	const formik = useFormik({
		initialValues: {
			text: "",
		},
		validateOnBlur: false,
		validateOnMount: false,
		validateOnChange: false,
		validationSchema: Yup.object().shape({
			text: Yup.string()
				.min(30,"Text should be greater then 30 characters to use ReTeam Avatar.")
				.max(5000, "Text should not be greater then 5000 characters to use ReTeam Avatar.")
				.required("Text is required field to go further."),
		}),
		onSubmit: async (values) => {
			try {
				continueToGenerate(values.text);
			} catch (e) {
				console.log(e);
			}
		}
	});

	useEffect(() => {

		return () => {
			setUploadProgress(0);
			setDisplayInputField(false);
		}

	}, [])

	const selectOption = async (option) => {
		let media = null;

		if (option === 2) {
			setLoading(true);
			media = await sendToS3(attachment, setUploadProgress);
			var subtitleResponse = await GeneralService.generateTranscription({
				team_id: team.id,
				media: media
			});
			formik.setFieldValue("text", subtitleResponse.data.data.content);
			clearAttachment();
			setUploadProgress(`${100}%`);
			setLoading(false);
			setDisplayInputField(true);
		}
	}

	return (
		<>
			{!displayInputField && (
				<div className='select-option'>
					<div>
						<span>Please select the option. Please note that after selecting the media, the text will going to replace by the media transcribe text.</span>
					</div>
					<div className='display-options'>
						<Button disabled={loading} onClick={() => selectOption(1)} buttonClass="grad_btn option-btn">Text</Button>
						<Button disabled={loading} onClick={() => selectOption(2)} buttonClass="grad_btn option-btn">	{!loading ? "Media" : <div style={{ display: 'flex', width: '100%', justifyContent: 'center', textAlign: 'center', gap: "10px" }}>{progressBar} <Loader width={25} height={25} /></div>}</Button>
					</div>
				</div>
			)}
			{displayInputField && (
				<div className='transcribe-text'>
					<span>Transcribe Text</span>
					<div>
						<CustomTextArea
							errorClass="textStyle"
							textColor={"black"}
							textAreaClass="form-control create-text-padding"
							formik={formik}
							placeholder="New Thoughts, Inspirations, Actions"
							fieldName={"text"}
							rows={3}
						/>
					</div>
					<div>
						<Button onClick={formik.handleSubmit}>Continue</Button>
					</div>
				</div >
			)
			}
		</>
	)
}

export default SelectionModal